import React, {useMemo} from 'react';

import {
  AssignableLaneWithStepType,
  AssignFormAssignToLanes,
} from './AssignableLanes';
import {AssignableStepType, AssignFormAssignToSteps} from './AssignableSteps';

import {
  AssigneesByType,
  GranularTaskAssignmentsType,
  SetAssignmentsType,
} from '../types';

interface Props {
  steps: AssignableStepType[];
  lanes: AssignableLaneWithStepType[];
  assignments: GranularTaskAssignmentsType;
  setAssignments: SetAssignmentsType;
}

export function AssignableLists({
  lanes,
  steps,
  assignments,
  setAssignments,
}: Props) {
  const assignmentsMap = useMemo(
    () =>
      assignments.reduce(
        (map, a) => {
          const container = a.lane != null ? map.lanes : map.steps;
          const id: string = a.lane ?? a.step_id!;

          if (container[id] == null) {
            container[id] = {
              users: [],
              roles: [],
              teams: [],
            };
          }

          if (a.user != null) {
            container[id].users.push(a.user);
          } else if (a.team != null) {
            container[id].teams.push(a.team);
          } else {
            container[id].roles.push(a.role);
          }

          return map;
        },
        {lanes: {}, steps: {}} as {
          [type in 'lanes' | 'steps']: {[id: string]: AssigneesByType};
        }
      ),
    [assignments]
  );

  return (
    <>
      {lanes.length > 0 ? (
        <div className="mb-4">
          <AssignFormAssignToLanes
            lanes={lanes}
            assignments={assignmentsMap.lanes}
            setAssignments={setAssignments}
          />
        </div>
      ) : null}
      <AssignFormAssignToSteps
        steps={steps}
        lanes={lanes}
        assignments={assignmentsMap}
        setAssignments={setAssignments}
      />
    </>
  );
}
